import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import toast from 'react-hot-toast';

const s: any = {
  page:  { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' },
  box:   { background: 'white', padding: 40, borderRadius: 12, width: 360, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
  label: { display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' as any, marginBottom: 16 },
  btn:   { width: '100%', padding: 12, background: '#2563EB', color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' }
};

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const nav = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      nav('/dashboard');
    } catch (err: any) { toast.error(err.response?.data?.error || 'Login failed'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <form onSubmit={submit} style={s.box}>
        <h1 style={{ marginBottom: 24, fontSize: 24, fontWeight: 700 }}>QuotationBot 🤖</h1>
        <label style={s.label}>Email</label>
        <input value={email} onChange={e => setEmail(e.target.value)} type="email" required style={s.input} />
        <label style={s.label}>Password</label>
        <input value={password} onChange={e => setPassword(e.target.value)} type="password" required style={s.input} />
        <button type="submit" disabled={loading} style={s.btn}>{loading ? 'Logging in...' : 'Login'}</button>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#666' }}>
          No account? <Link to="/signup" style={{ color: '#2563EB' }}>Sign up free</Link>
        </p>
      </form>
    </div>
  );
}